export default "__VITE_ASSET__nFnL0RuJ__"